import axios from 'axios';
import { Envelope } from '../interfaces/envelope';
import { Device } from '../interfaces/devices';

async function getDevices(): Promise<Device[]> {
	try {
		const response = await axios.get<Envelope<Device[]>>(`devices`);
		return response.data.data;
	} catch (error) {
		if (axios.isAxiosError(error)) {
			throw error.response!.data;
		}
		throw error;
	}
}

async function getDevicesCategory(category: string): Promise<Device[]> {
	try {
		const response = await axios.get<Envelope<Device[]>>(`devices/${category}`);
		return response.data.data;
	} catch (error) {
		if (axios.isAxiosError(error)) {
			throw error.response!.data;
		}
		throw error;
	}
}

async function getDevice(deviceId: number): Promise<Device> {
	try {
		const response = await axios.get<Envelope<Device>>(`devices/${deviceId}`);
		return response.data.data;
	} catch (error) {
		if (axios.isAxiosError(error)) {
			throw error.response!.data;
		}
		throw error;
	}
}

export const devices = {
	getDevices,
	getDevicesCategory,
	getDevice,
};
